module.exports = __webpack_public_path__ + "static/media/sctp.0720f4e4.ico";